
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.5.978a2 2 0 00-1.008.27v.002L2.495 4.165a1.334 1.334 0 00-.662 1.151V12c0 .729.605 1.333 1.334 1.333h10.666c.73 0 1.334-.604 1.334-1.333V5.316c0-.472-.253-.912-.662-1.15L9.508 1.25A2 2 0 008.5.978zm0 1.332c.116 0 .232.03.336.091l4.997 2.915v.032L9.204 8.23a1.332 1.332 0 01-1.408 0l-4.63-2.88v-.033l4.998-2.915A.665.665 0 018.5 2.31zm0 1.161a.332.332 0 00-.236.098L7.07 4.764a.333.333 0 00.236.57h.528v1.333a.667.667 0 001.334 0V5.333h.528a.333.333 0 00.236-.569L8.736 3.57a.333.333 0 00-.236-.098z"}})])
          )
        }
      }
    